<template>
  <el-dialog :visible.sync="dialogVisible" :fullscreen="true" :show-close="false" @close="handleClose">
    <div class="diaInner" id="diaInner">
      <h3 class="diainner_title">
        动土安全作业
        <div class="diainner_title_num">编号：{{ message.no }}</div>
      </h3>
      <table border="1">
        <!-- <tr>
          <td class="title" :colspan="2">作业名称</td>
          <td :colspan="7">{{ message.name }}</td>
        </tr> -->
        <tr>
          <td class="title" :colspan="2">申请单位</td>
          <td :colspan="3">{{ message.applicant?.contrName }}</td>
          <!-- <td class="title">申请人</td>
          <td>{{ getUserName(message.applyUserId) }}</td> -->
          <td class="title" :colspan="2">作业申请时间</td>
          <td :colspan="3">{{ message.applyTime }}</td>
        </tr>
        <tr>
          <td class="title" :colspan="2">作业单位</td>
          <td :colspan="2">{{ message.businessJson.workUnit }}</td>
          <td class="title" :colspan="2">作业地点</td>
          <td :colspan="1">{{ message.place }}</td>
          <td class="title" :colspan="1">作业内容</td>
          <td :colspan="2">{{ message.businessJson.content }}</td>
        </tr>
        <tr>
          <td class="title" :colspan="2">监护人</td>
          <td :colspan="3">{{ getUserName(message.businessJson.guardianId) }}</td>
          <td class="title" :colspan="2">作业负责人</td>
          <td :colspan="3">{{getUserName(message.businessJson.companyCharger) }}</td>
        </tr>
        <tr>
          <td class="title" :colspan="1">涉及的其他特殊作业及编号</td>
          <td :colspan="8">{{ formatPreWorkInfo() }}</td>
        </tr>
        <tr>
          <td :colspan="9">
            <div class="fireplayidea_title">作业范围、内容、方式(包括深度、面积):</div>
            <div class="fireplayidea_cont">
              作业范围、内容、方式(包括深度、面积)<br />
              {{ message.businessJson.description }}
            </div>
            <div class="fireplayidea_right">
              <span>签字：{{ getUserName(message.businessJson.signId) }}</span>
              <span>签字时间：{{ message.businessJson.signTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td class="title" :colspan="2">风险辨识结果</td>
          <td :colspan="8">{{ message.businessJson.hi }}</td>
        </tr>
        <tr>
          <td class="title" :colspan="2">作业实施时间</td>
          <td :colspan="8">{{ message.planStartTime }}- {{ message.planEndTime }}</td>
        </tr>
        <tr>
          <td class="title" :colspan="2">序号</td>
          <td class="title" :colspan="4">安全措施</td>
          <td class="title" :colspan="2">是否涉及</td>
          <td class="title" :colspan="2">确认人</td>
        </tr>
        <tr v-for="(item3, index3) in message.businessJson.sms" :key="index3 + '-' + item3.confirmorId">
          <td>{{ index3 + 1 }}</td>
          <td :colspan="5" class="keepLeft">{{ item3.measures }}</td>
          <td :colspan="2">{{ item3.isInvolve == 1 ? '是' : '否' }}</td>
          <td><i v-html="getSignatureImg(item3.orderNo, 40)" /></td>
        </tr>
        <tr>
          <td :colspan="3" class="title">安全交底人</td>
          <td :colspan="2">{{ getUserName(message.businessJson.implementId) }}</td>
          <td :colspan="2" class="title">接受交底人</td>
          <td :colspan="3">{{ getUserName(message.businessJson.acceptId) }}</td>
        </tr>
        <tr>
          <td :colspan="10">
            <div class="fireplayidea_title">作业负责人意见</div>
            <div class="fireplayidea_cont">{{ message.businessJson.companyChargerComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.companyChargerOrder, 60)" /></span>
              <span>签字时间：{{ message.businessJson.companyChargerTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="10">
            <div class="fireplayidea_title">所在单位意见</div>
            <div class="fireplayidea_cont">{{ message.businessJson.branchChargerComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.branchChargerOrder, 60)" /></span>
              <span>签字时间：{{ message.businessJson.branchChargerTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="10">
            <div class="fireplayidea_title">有关水、电、汽、工艺、设备、消防、安全等部门负责人会签意见</div>
            <div class="fireplayidea_cont">{{ message.businessJson.deptChargerComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.deptChargerOrder, 60)" /></span>
              <span>签字时间：{{ message.businessJson.deptChargerTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="10">
            <div class="fireplayidea_title">审批部门意见</div>
            <div class="fireplayidea_cont">{{ message.businessJson.approveChargerComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.approveChargerOrder, 60)" /></span>
              <span>签字时间：{{ message.businessJson.approveChargerTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="10">
            <div class="fireplayidea_title">完工验收</div>
            <div class="fireplayidea_cont">{{ message.acceptanceOpinion }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(0, 60)" /></span>
              <span>签字时间：{{ message.acceptanceTime }}</span>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <span slot="footer" class="diaFooter">
      <el-button @click="handleClose" size="small">取 消</el-button>
      <el-button v-if="!isWork" type="primary" v-print="'#diaInner'" size="small">打 印</el-button>
    </span>
  </el-dialog>
</template>

<script>
import signatureImg from "@/assets/img/签字.png";

export default {
  name: 'blindBoard',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    message: {
      type: Object,
      default: {}
    },
    userList: {
      type: Array,
      default: []
    },
    isWork: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  methods: {
    formatPreWorkInfo() {
      if (!this.message.preWorkInfo) {
        return
      }
      let str = []
      let data = JSON.parse(this.message.preWorkInfo)
      for (var i = 0; i < data.length; i++) {
        let element = data[i]
        str.push(`${element.name}(${element.no})`)
      }
      str = str.join(',')
      return str
    },
    handleClose() {
      this.$emit('componentResult', false)
    },
    getUserName(id) {
      for (let i in this.userList) {
        if (id === this.userList[i].id) {
          return this.userList[i].name
        }
      }
    },
    getSignatureImg(orderNum, height = 40) {
      let signatureImg = require('@/assets/img/签字.png');
      let signatureImgHeight = 'auto';
      for (let i in this.message.reviewContentJson) {
        if (orderNum === this.message.reviewContentJson[i].orderNum) {
          let img = this.message.reviewContentJson[i].signatureImg;
          if (img) {
            signatureImg = img;
            signatureImgHeight = height + 'px'
          }
        }
      }

      return '<img style="height: ' + signatureImgHeight + '" src="' + signatureImg + '"/>';
    },
  }
}
</script>

<style src="./commonTable.css" scoped></style>

<style>
.diaInner {
  width: 1020px;
  margin: auto;
}

table {
  width: 1020px;
}

td {
  width: 150px;
}

.diainner_title {
  text-align: center;
  font-size: 28px;
  position: relative;
}

.diainner_title .diainner_title_num {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 14px;
  font-weight: normal;
}

.fireplayidea_title {
  font-size: 14px;
  text-align: left;
  font-weight: bold;
}

.fireplayidea_cont {
  line-height: 22px;
  text-align: left;
  margin: 10px 0;
}

.fireplayidea_right {
  text-align: right;
}

.fireplayidea_right span {
  margin-left: 10px;
  width: 220px;
  display: inline-block;
  text-align: left;
}</style>
